import React from 'react';
import FullCalendarComponent from './components/CannabisCalendar';

function App() {
  return (
    <div className="min-h-screen bg-gray-900 text-white">
      <FullCalendarComponent />
    </div>
  );
}

export default App;